<template>
  <div>
    <!-- <v-text-field outlined :label="label" placeholder="https://...." v-model="image"></v-text-field> -->

    <v-img v-if="image" :src="image" :lazy-src="placeholderImage" max-width="500" max-height="300">
      <template v-slot:placeholder>
        <v-row class="fill-height ma-0" align="center" justify="center">
          <h3 class="grey--text lighten-1">Bild</h3>
        </v-row>
      </template>
    </v-img>
    <div class="bottom mt-2">
      <v-btn color="primary" text @click="newImageDialog = true"> Ändra bild </v-btn>
    </div>
    <ImagePick
      :visible="newImageDialog"
      @close="newImageDialog = false"
      @change="onChange"
    ></ImagePick>
  </div>
</template>

<script>
import placeholderImage from '@/assets/placeholder-image.webp'
import ImagePick from './ImagePick.vue'

export default {
  name: 'ImageComponent',
  props: {
    value: {
      type: String,
    },
    label: { type: String },
  },
  components: {
    ImagePick,
  },
  data() {
    return {
      placeholderImage,
      newImageDialog: false,
    }
  },
  computed: {
    image: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  methods: {
    onChange(value) {
      if ('type' in value && value.type === 'video') {
        this.$emit('add-video', value)
      } else {
        this.image = value.id
      }
      this.newImageDialog = false
    },
  },
}
</script>

<style lang="less" scoped>
.bottom {
  display: flex;
  justify-content: flex-end;
}
</style>
